/* eslint-disable */
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Popup from 'reactjs-popup';
import { FaSpinner } from 'react-icons/fa';


class SiteNotification extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    return (
      this.props.showNotification ? (<section className="site-notification">
        <Popup modal defaultOpen={true} closeOnDocumentClick={false} onClose={() => this.props.onClose()}>
          {close => (
            <div className="notification-popup">
              <span>
                <a className="close" onClick={close}>
                  Close &times;
        </a>
                {this.props.content}

                <div className="header" style={{ marginTop: "20px" }}><h3>Welcome to CRCK</h3></div>

                <h5 className="text-center" style={{ marginTop: "20px" }} dangerouslySetInnerHTML={{ __html: this.props.html }} />
                {this.props.loading ? <FaSpinner /> : ''}



              </span>
            </div>
          )}
        </Popup >
      </section >) : ''
    );
  }
}

export default SiteNotification;
